import { render, staticRenderFns } from "./ProductPPLS.vue?vue&type=template&id=10d017ec&"
import script from "./ProductPPLS.vue?vue&type=script&lang=js&"
export * from "./ProductPPLS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports